module.exports = __webpack_public_path__ + "img/notfound.3da721b7.png";